export default class MediaRecordingActions {

  constructor() {
    this.recordSourceSelected = 1;
    this.enableAudio = true;
    this.enableScreen = false;
    this.isAudioAllowed = false;
    this.isVideoAllowed = false;
  }  

  getRecordSourceSelected() {
    return this.recordSourceSelected;
  };

  setRecordSourceSelected = (index) => {
    this.recordSourceSelected = index;
  }

  getAudioAllowed() {
    return this.isAudioAllowed;
  };

  setAudioAllowed = (value) => {
    this.isAudioAllowed = value;
  }
  
  getVideoAllowed() {
    return this.isVideoAllowed;
  };

  setVideoAllowed = (value) => {
    this.isVideoAllowed = value;
  }  

  onStartRecord(startRecording) {
    this.enableScreen = true;
    return startRecording();
  }   

  onMuteAudio(muteAudio) {
    this.enableAudio = false;
    return muteAudio();
  }

  onUnMuteAudio(unMuteAudio) {
    this.enableAudio = true;
    return unMuteAudio();
  }  

  onClearBlobUrl(clearBlobUrl) {
    return clearBlobUrl();
  }  

  isEnableScreen() {
    return this.enableScreen;
  } 
  
  isEnableAudio() {
    return this.enableAudio;
  }   

}
